export default {
    setCars(state, payload){
        state.cars = payload;
    },

    setPages(state, payload){
        state.pages = payload;
    }
}